var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "subscription" } }, [
    _c("h2", [_vm._v("プレミアムユーザーになりましょう")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "lds-roller"
      },
      [
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div")
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.result,
            expression: "result"
          }
        ]
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.success,
                expression: "success"
              }
            ]
          },
          [
            _c("p", [_vm._v("プレミアム会員になりました😃")]),
            _vm._v(" "),
            _c("p", [_vm._v("5秒後にTOPページへ移動します")])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.success,
                expression: "!success"
              }
            ]
          },
          [
            _c("p", { staticClass: "has-text-danger" }, [
              _vm._v("決済に失敗しました...🙏")
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.loading && _vm.main,
            expression: "!loading && main"
          }
        ]
      },
      [
        _c("vue-stripe-checkout", {
          ref: "checkoutRef",
          attrs: {
            image: _vm.checkoutOptions.image,
            name: _vm.checkoutOptions.name,
            description: _vm.checkoutOptions.description,
            currency: _vm.checkoutOptions.currency,
            amount: _vm.checkoutOptions.amount,
            "allow-remember-me": true,
            locale: _vm.checkoutOptions.locale
          },
          on: {
            done: _vm.done,
            opened: _vm.opened,
            closed: _vm.closed,
            canceled: _vm.canceled
          }
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button is-success",
            on: { click: _vm.checkoutMonth }
          },
          [_vm._v("月額300円 by Stripe")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "button is-primary", on: { click: _vm.checkoutYear } },
          [_vm._v("年額3000円 by Stripe")]
        ),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "tile is-ancestor" }, [
          _c("div", { staticClass: "tile is-parent" }, [
            _c("article", { staticClass: "tile is-child box" }, [
              _c("p", { staticClass: "title" }, [
                _vm._v("キャンセルはとても簡単")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c(
                  "p",
                  [
                    _vm._v("ログインした状態で"),
                    _c("router-link", { attrs: { to: "/unsubscription" } }, [
                      _vm._v("こちら")
                    ]),
                    _vm._v("から可能です。")
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _vm._m(3)
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "info" }, [
      _vm._v("画面が切り替わるまで操作をしないでください🙅"),
      _c("br"),
      _vm._v(
        "\n      メールアドレスは、このサービスに登録しているメールアドレスと同じものにしてください👍"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tile is-ancestor" }, [
      _c("div", { staticClass: "tile is-parent" }, [
        _c("article", { staticClass: "tile is-child box" }, [
          _c("p", { staticClass: "title" }, [
            _vm._v("1ファイル容量の制限緩和")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("p", [
              _vm._v(
                "無料会員は1ファイル最大20MBまでですが、プレミアム会員では1ファイル"
              ),
              _c("b", [_vm._v("最大5GB！")]),
              _vm._v("まで対応してます。")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tile is-parent" }, [
        _c("article", { staticClass: "tile is-child box" }, [
          _c("p", { staticClass: "title" }, [
            _vm._v("同時アップロード数の無制限")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("p", [
              _vm._v(
                "無料会員は同時に3ファイルまでしかアップロードできませんが、プレミアム会員では"
              ),
              _c("b", [_vm._v("無制限")]),
              _vm._v("です。")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tile is-ancestor" }, [
      _c("div", { staticClass: "tile is-parent" }, [
        _c("article", { staticClass: "tile is-child box" }, [
          _c("p", { staticClass: "title" }, [
            _vm._v("ファイルの種類は何でもOK")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("p", [
              _vm._v(
                "無料会員はアップロードできるファイルの種類に制限がありますが、プレミアム会員では"
              ),
              _c("b", [_vm._v("どんなファイルもアップロード可能")]),
              _vm._v("です。")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "tile is-parent" }, [
        _c("article", { staticClass: "tile is-child box" }, [
          _c("p", { staticClass: "title" }, [_vm._v("画像の品質はそのままに")]),
          _vm._v(" "),
          _c("div", { staticClass: "content" }, [
            _c("p", [
              _vm._v("無料会員は画像の圧縮がありますが、プレミアム会員では"),
              _c("b", [_vm._v("そのままの画質")]),
              _vm._v("を利用できます。")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tile is-parent" }, [
      _c("article", { staticClass: "tile is-child box" }, [
        _c("p", { staticClass: "title" }, [
          _vm._v("毎月300円 or 年額3000円の定額課金")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("p", [
            _vm._v(
              "どんなにファイルをアップロードしても請求額は変わりません。決済には"
            ),
            _c(
              "a",
              { attrs: { href: "https://stripe.com/jp", title: "Stripe" } },
              [_vm._v("Stripe")]
            ),
            _vm._v("を使用しています。")
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38f216cd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38f216cd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subscription.vue
// module id = null
// module chunks = 